var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.822,
    height: 18.822,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16676",
    d: "M9.411 0a9.368 9.368 0 1 0 6.667 2.744A9.411 9.411 0 0 0 9.411 0Zm4.877 7.016L8.3 13a.813.813 0 0 1-1.2 0l-2.523-2.52a.941.941 0 0 1-.171-1.155.856.856 0 0 1 1.326-.086L7.7 11.208l5.39-5.39a.856.856 0 0 1 1.2 1.2Z",
    fill: "#5ed142"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.fdf245dd59680dba316a5cd6246e470b.svg";
export { ForwardRef as ReactComponent };